export const getPassengersText = (count?: number): string => {
  if (!count || count < 1 || count > 5) {
    return ''
  }

  const keys = [
    'tours_block.special_tours.one',
    'tours_block.special_tours.two',
    'tours_block.special_tours.three',
    'tours_block.special_tours.four',
    'tours_block.special_tours.five',
  ]

  return keys[count - 1]
}
